import { ProjectOrGoalStatusPhase } from '@townsquare/status-summary/types';

export const isStatusFilterValid = (newStatus: string): boolean => {
	return Object.values(ProjectOrGoalStatusPhase).findIndex((s) => s === newStatus) !== -1;
};
